import { useState } from 'react';
import { getKeyName } from '../QueriedContent/DetailGene';

export default function GeneSynonyms({ geneDetailInfo }) {

  const { synonyms } = geneDetailInfo;
  const [showAll, setShowAll] = useState(false);

  const nonOfficialSynonyms = synonyms.filter(s => !s.isOfficial);
  const visibleSynonyms = showAll ? nonOfficialSynonyms : nonOfficialSynonyms.slice(0, 10);

  return (
    <div className="table-container">
      <table className="table table-condensed table-condenseddg">
        <tbody>
          {visibleSynonyms.map((synonym, index) => (
            <tr key={getKeyName(synonym.name) + index}>
              <td className="col-md-6 text-xs font-semibold">{synonym.name}</td>
            </tr>
          ))}

          {nonOfficialSynonyms.length > 10 && !showAll && (
            <tr>
              <td className="text-left">
                <button
                  style={{ color: 'rgb(107, 151, 208)' }}
                  className="text-xs font-semibold"
                  onClick={() => setShowAll(true)}
                >
                  +{nonOfficialSynonyms.length - 10} synonyms
                </button>
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}
